import type { IconDef } from '../types';

// Figma `Icon/warning`: a 23×20.5 glyph exported at the frame's top-left,
// shifted here by (0.5, 1.75) so it sits centred in the 24×24 box like the
// rest of the set.
export const warning: IconDef = {
  viewBox: '0 0 24 24',
  paths: [
    {
      d: 'M12 1.75L23.5 22.25H0.5L12 1.75ZM11 8.75H13V15.25H11V8.75ZM11 17.25H13V19.25H11V17.25Z',
      fillRule: 'evenodd',
      clipRule: 'evenodd',
    },
  ],
};
